import type { GeoCoordinates, PhoneNumber } from '@hetivo/hetivo-lib-types';

import type { AddressFormValues, LocationCoordinatesFormValues } from '../schemas/create-location.schema';

// ─── Helpers ──────────────────────────────────────────────────────────────────

export function hasAddressData(address: AddressFormValues | undefined): boolean {
  return (
    address !== undefined &&
    typeof address.city === 'string' &&
    address.city.trim().length > 0 &&
    typeof address.country === 'string' &&
    address.country.trim().length > 0
  );
}

export function hasPhoneData(phone: PhoneNumber | null | undefined): phone is PhoneNumber {
  return phone !== null && phone !== undefined && phone.dialCode !== '' && phone.number !== '';
}

export function toGeoCoordinates(coordinates: LocationCoordinatesFormValues | undefined): GeoCoordinates | undefined {
  if (coordinates?.x === undefined || coordinates.y === undefined) return undefined;
  return { x: coordinates.x, y: coordinates.y };
}

export function normaliseGeocodingScore(score: number | undefined): number | undefined {
  return score !== undefined && score !== null ? score / 100 : undefined;
}
